import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "attr-val"
};
const _hoisted_4 = {
  class: "attr-val"
};
const _hoisted_5 = {
  class: "attr-val-blue"
};
const _hoisted_6 = {
  class: "attr-val-blue"
};
const _hoisted_7 = {
  style: {
    "color": "#1d90e6",
    "font-size": "1.1em"
  }
};
const _hoisted_8 = {
  style: {
    "color": "red",
    "font-size": "1.1em"
  }
};
const _hoisted_9 = {
  class: "attr-val"
};
const _hoisted_10 = {
  class: "attr-val"
};
const _hoisted_11 = {
  class: "attr-val"
};
const _hoisted_12 = {
  class: "bottom_div"
};
const _hoisted_13 = {
  class: "left"
};
const _hoisted_14 = {
  class: "image"
};
const _hoisted_15 = {
  key: 1,
  class: "other-image"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 3,
  class: "sms_con"
};
const _hoisted_19 = {
  key: 4,
  class: "other-image"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "right"
};
const _hoisted_22 = {
  style: {
    "font-size": ".8em",
    "margin-top": "10px"
  }
};
const _hoisted_23 = {
  class: "down_list"
};
const _hoisted_24 = {
  class: "attr-val-blue"
};
const _hoisted_25 = {
  class: "attr-val"
};
const _hoisted_26 = {
  class: "un_down_list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_card = _resolveComponent("el-card");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    bodyStyle: _ctx.bodyStyle
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8,
        class: "row_col_1"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: require('@/assets/images/common/envelop.png')
        }, null, 8, _hoisted_1), _cache[0] || (_cache[0] = _createElementVNode("span", {
          style: {
            "font-weight": "bold"
          }
        }, "素材名称：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.posBizInfo.assetBaseInfo.assetsName), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        class: "row_col_1"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: require('@/assets/images/common/envelop.png')
        }, null, 8, _hoisted_2), _cache[1] || (_cache[1] = _createElementVNode("span", {
          style: {
            "font-weight": "bold"
          }
        }, "活动名称：", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.posBizInfo.actName), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 7,
        push: 4
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $setup.putAsset
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("修改素材", -1)]))]),
          _: 1
        }, 8, ["onClick"])), [[_directive_has, 'off:line:asset:update']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          loading: _ctx.isDownloading,
          type: "primary",
          size: "small",
          onClick: $setup.downAsset
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("下载素材", -1)]))]),
          _: 1
        }, 8, ["loading", "onClick"])), [[_directive_has, 'off:line:asset:down']])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "row_2",
      style: {
        "margin-top": "5px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 7,
        push: 1,
        class: "row_col_2"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_cache[4] || (_cache[4] = _createTextVNode("素材投放人：", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.posBizInfo.createByName), 1)]), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createTextVNode("投放时间：", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.posBizInfo.createTime), 1)])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        push: 2,
        class: "row_col_2"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_cache[6] || (_cache[6] = _createTextVNode("投放运营位：", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.posBizInfo.assetsPosNames.join("，")), 1)]), _createElementVNode("div", null, [_cache[7] || (_cache[7] = _createTextVNode("投放渠道：", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.posBizInfo.areaList.join("，")), 1)])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 1
      }), _createVNode(_component_el_col, {
        span: 2,
        class: "row_col_2 right"
      }, {
        default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "gray_sta"
        }, "状态", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.posBizInfo.lineFlag), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: "row_col_2 right"
      }, {
        default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "gray_sta"
        }, "是否必须投放", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.posBizInfo.mustPut == 1 ? '是' : '否'), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "row_2"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10,
        push: 1,
        class: "row_col_2"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_cache[10] || (_cache[10] = _createTextVNode("素材有效期：", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.posBizInfo.assetBaseInfo.bgnDate + '至' + _ctx.posBizInfo.assetBaseInfo.endDate), 1)])]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10,
        class: "row_col_2"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_cache[11] || (_cache[11] = _createTextVNode("投放有效期：", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.posBizInfo.bgnDate + '至' + _ctx.posBizInfo.endDate), 1)])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "row_2"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        push: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_cache[12] || (_cache[12] = _createTextVNode("备注：", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.posBizInfo.remark), 1)])]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[13] || (_cache[13] = _createElementVNode("div", {
      class: "title"
    }, "运营位素材预览", -1)), _createElementVNode("div", _hoisted_14, [_ctx.posBizInfo.assetBaseInfo.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      fit: "contain",
      style: {
        "width": "100%",
        "height": "397px"
      },
      src: _ctx.posBizInfo.assetBaseInfo.srcOutUrl ? _ctx.posBizInfo.assetBaseInfo.srcOutUrl : _ctx.posBizInfo.assetBaseInfo.srcInnUrl
    }, null, 8, ["src"])) : _createCommentVNode("", true), _ctx.posBizInfo.assetBaseInfo.srcTyp === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("audio", {
      style: {
        "width": "276px"
      },
      src: _ctx.posBizInfo.assetBaseInfo.srcOutUrl ? _ctx.posBizInfo.assetBaseInfo.srcOutUrl : _ctx.posBizInfo.assetBaseInfo.srcInnUrl,
      controls: "controls"
    }, null, 8, _hoisted_16)])) : _createCommentVNode("", true), _ctx.posBizInfo.assetBaseInfo.srcTyp === '3' ? (_openBlock(), _createElementBlock("video", {
      key: 2,
      style: {
        "width": "100%",
        "height": "397px"
      },
      src: _ctx.posBizInfo.assetBaseInfo.srcOutUrl ? _ctx.posBizInfo.assetBaseInfo.srcOutUrl : _ctx.posBizInfo.assetBaseInfo.srcInnUrl,
      autoplay: "",
      muted: "",
      controls: "controls"
    }, " 您的浏览器不支持 HTML5 video 标签。 ", 8, _hoisted_17)) : _createCommentVNode("", true), _ctx.posBizInfo.assetBaseInfo.srcTyp === '7' ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.posBizInfo.assetBaseInfo.content), 1)) : _createCommentVNode("", true), _ctx.posBizInfo.assetBaseInfo.srcTyp != undefined && _ctx.posBizInfo.assetBaseInfo.srcTyp !== '1' && _ctx.posBizInfo.assetBaseInfo.srcTyp !== '2' && _ctx.posBizInfo.assetBaseInfo.srcTyp !== '3' && _ctx.posBizInfo.assetBaseInfo.srcTyp !== '7' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
      style: {
        "width": "120px",
        "height": "120px"
      },
      src: _ctx.srcType[_ctx.posBizInfo.assetBaseInfo.srcTyp] && _ctx.srcType[_ctx.posBizInfo.assetBaseInfo.srcTyp].src ? _ctx.srcType[_ctx.posBizInfo.assetBaseInfo.srcTyp].src : _ctx.srcType[6].src
    }, null, 8, _hoisted_20)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_21, [_cache[18] || (_cache[18] = _createElementVNode("div", {
      class: "title"
    }, [_createTextVNode("投放概况"), _createElementVNode("span", {
      class: "attr-val",
      style: {
        "font-size": ".6em",
        "font-weight": "normal",
        "margin-left": "10px"
      }
    }, "(截止今日)")], -1)), _createElementVNode("div", _hoisted_22, [_cache[16] || (_cache[16] = _createElementVNode("div", {
      class: "attr-val"
    }, "已下载渠道：", -1)), _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posBizInfo.positionBizDownList, down => {
      return _openBlock(), _createElementBlock("div", {
        class: "down_item",
        key: down.downAreaCode
      }, [_createElementVNode("div", _hoisted_24, _toDisplayString(down.downAreaName), 1), _createElementVNode("div", _hoisted_25, [_cache[14] || (_cache[14] = _createTextVNode("下载时间：", -1)), _createElementVNode("span", null, _toDisplayString(down.downTime), 1)])]);
    }), 128))]), _cache[17] || (_cache[17] = _createElementVNode("div", {
      class: "attr-val",
      style: {
        "margin-top": "20px"
      }
    }, "未下载渠道：", -1)), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posBizInfo.unDownAreaNameList, (unDown, ind) => {
      return _openBlock(), _createElementBlock("div", {
        key: ind
      }, _toDisplayString(unDown), 1);
    }), 128))]), _ctx.posBizInfo.unDownAreaNameList.length > 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary",
      size: "mini",
      onClick: $setup.sendRemindSms
    }, {
      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("下发提醒短信", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])])])]),
    _: 1
  }, 8, ["bodyStyle"]);
}